import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import t from '@jetshop/intl';
import { DropdownMenuButton as Button } from '@jetshop/ui/DropdownMenu';
import { ReactComponent as Carot } from '@jetshop/ui/svg/Carrot.svg';
import { ReactComponent as Check } from '../../../svg/Check.svg';
import React, { useState, useEffect } from 'react';
import { FilterDropdownMenu } from './FilterDropdownMenu';
import { RangeSliderContainer, wrapper } from './RangeFilters';
import { DropdownMenuItems } from '@jetshop/ui/DropdownMenu';
import RangeButton from '@jetshop/ui/Button';
import { categoryLabelStyle } from './ListFilters';
import { MultiRangeSlider } from './MulitRangeSlider/MultiRangeSlider';
import { styled } from 'linaria/react';
import { ReactComponent as Cross } from '@jetshop/ui/svg/Cross.svg';

const InnerWrapper = styled('div')`
  display: flex;
  button {
    position: absolute;
    right: 0;
    top: 12px;
    cursor: pointer;
    max-width: 25%;
  }
  svg {
    path {
      fill: black;
    }
  }
`;

export const FakedRangeFilter = ({ filter, mobile }) => {
  const { apply, clear } = useListFilter({ filter });

  const valueList = filter?.items?.map((item) => {
    return parseInt(item.value);
  });

  const [touched, setTouched] = useState(false);
  const initialMin = Math.min(...valueList);
  const initialMax = Math.max(...valueList);
  const [productCount, setProductCount] = useState(0);
  const activeList = filter?.items?.filter((item) => item?.isActive);
  const activeListValues = activeList?.map((val) => val.value);
  const activeMin =
    activeListValues?.length > 0 ? Math.min(...activeListValues) : initialMin;
  const activeMax =
    activeListValues?.length > 0 ? Math.max(...activeListValues) : initialMax;
  const [minRangeValue, setMinRangeValue] = useState(activeMin);
  const [maxRangeValue, setMaxRangeValue] = useState(activeMax);

  useEffect(() => {
    let tot = 0;
    valueList?.forEach((value) => {
      if (value >= minRangeValue && value <= maxRangeValue) {
        let item = filter.items.find(
          (item) => parseInt(item.value) === parseInt(value)
        );
        tot += item?.resultCount ?? 0;
      }
    });
    setProductCount(tot);
  }, [minRangeValue, maxRangeValue, valueList, filter]);

  const valuesChanged = ([min, max]) => {
    setTouched(true);
    setMinRangeValue(min);
    setMaxRangeValue(max);
  };

  const reset = () => {
    setTouched(false);
    setMinRangeValue(initialMin);
    setMaxRangeValue(initialMax);
    clear();
  };

  const applyFilter = () => {
    clear();
    valueList.forEach((value) => {
      let addFilterValue = value + '';
      if (value >= minRangeValue && value <= maxRangeValue) {
        apply({ value: addFilterValue, set: true });
      }
    });
    setTouched(false);
  };

  const sliderContent = (mobile) => {
    return (
      <RangeSliderContainer className={wrapper}>
        <p className={'count'}>({productCount})</p>
        <div className="active-vals">
          <span className={'value'}>{minRangeValue}cm</span>
          <span className={'value'}>{maxRangeValue}cm</span>
        </div>
        <MultiRangeSlider
          values={valueList}
          min={initialMin}
          max={initialMax}
          activeMin={activeMin}
          activeMax={activeMax}
          onChange={({ min, max }) => {
            valuesChanged([min, max]);
          }}
          mobile={mobile}
        />
        {touched ? (
          <RangeButton onClick={applyFilter}>{t('Apply')}</RangeButton>
        ) : (
          <RangeButton onClick={reset}>{t('Reset')}</RangeButton>
        )}
      </RangeSliderContainer>
    );
  };

  return (
    <>
      {mobile ? (
        <>{sliderContent(mobile)}</>
      ) : (
        <FilterDropdownMenu>
          <Button>
            <span>{filter.name}</span>
            {filter.hasActiveItems ? <Check /> : <Carot className="carot" />}
          </Button>
          <DropdownMenuItems as="div" closeOnClickOutside={true}>
            <>
              <ul
                style={{ listStyle: 'none', paddingLeft: '0px', margin: '0px' }}
              >
                <li>
                  <InnerWrapper>
                    <span className={categoryLabelStyle}>
                      {filter.name.toUpperCase()}
                    </span>
                    <Button>
                      <Cross />
                    </Button>
                  </InnerWrapper>
                </li>
              </ul>
              {sliderContent(false)}
            </>
          </DropdownMenuItems>
        </FilterDropdownMenu>
      )}
    </>
  );
};
